module.exports = __webpack_public_path__ + "img/choose-favorite.505c6f44.svg";